import axios from "axios";
import { getRestServiceUri } from "@/utils/ApiUtils";

export const HTTPWithoutAuth = axios.create({
  baseURL: getRestServiceUri(),
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 10000,
});
